import { Service, signal } from '@angular/core';

@Service()
export class NeedHelpService {
  show = signal(false);

  open(): void {
    this.show.set(true);
  }

  close(): void {
    this.show.set(false);
  }
}
